import { render, staticRenderFns } from "./CostShiftSuccessPage.vue?vue&type=template&id=a9d567d2&scoped=true"
import script from "./CostShiftSuccessPage.vue?vue&type=script&lang=js"
export * from "./CostShiftSuccessPage.vue?vue&type=script&lang=js"
import style0 from "./CostShiftSuccessPage.vue?vue&type=style&index=0&id=a9d567d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d567d2",
  null
  
)

export default component.exports